import { Api } from "../helpers";

export const regionService = {
  createRegion,
  removeRegion
};


// create new region, pass data
function createRegion(options) {
  return Api()
    .post("/region", options.data)
    .then(response => {
      // return accept-protocol by id
      // {id: 1, name: "Virtual PBX", language_id: 1, version: 1, enabled: 1,…}
      return response.data;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

// remove question from pivot table
function removeRegion(options) {
  console.log("options", options)

  return Api()
    .delete("/region/" + options.id, { data: options.data })
    .then(() => {
      return true;
    })
    .catch(err => {
      console.log("error:", err);
      return Promise.reject(err);
    });
}
